// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar {
  height: 100%;
  max-width: 13rem;
  padding: 0.5rem;
  background: var(--Foreground);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  border-radius: 0.75rem;
  overflow: auto;
  min-width: 13rem;
}
.Sidebar header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 0.0625rem solid var(--Stroke);
}
.Sidebar header .Icon {
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;
  border-radius: 0.5rem;
  background: var(--Background);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
  line-height: 1.125rem;
  font-weight: 700;
  color: var(--TextColor);
  -webkit-user-select: none;
          user-select: none;
}
.Sidebar header .CompanyNameEmail {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  overflow: hidden;
}
.Sidebar header .CompanyNameEmail .CompanyName {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--TextColor);
  cursor: default;
}
.Sidebar header .CompanyNameEmail .CompanyEmail {
  font-size: 0.625rem;
  font-weight: 400;
  color: var(--TextColor);
}
.Sidebar nav {
  flex: 1 1;
  padding: 0.25rem;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.Sidebar nav .NavLink {
  padding: 0.375rem 0.75rem 0.375rem 0.75rem;
  border-radius: 0.5rem;
  color: var(--TextColor);
  font-size: 0.875rem;
  cursor: pointer;
  text-decoration: none;
}
.Sidebar nav .NavLink:hover {
  color: var(--AccentColor);
  background: var(--Background);
}
.Sidebar nav .Active {
  background: var(--AccentColor);
  color: #ffffff;
  font-weight: 700;
  padding: 0.375rem 0.75rem 0.375rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  text-decoration: none;
}
.Sidebar footer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.Sidebar footer .ToggleTheme {
  flex: 1 1;
  height: 2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem;
  background: var(--Background);
  border-radius: 0.5rem;
  transition: all 0.3s ease-in-out;
  position: relative;
  cursor: pointer;
}
.Sidebar footer .ToggleTheme .Opacity {
  opacity: 0.5;
  transition: all 0.3s ease;
}
.Sidebar footer .ToggleTheme .ToggleIndicator {
  width: 50%;
  height: 1.5rem;
  position: absolute;
  top: 0.25rem;
  background: var(--Foreground);
  border-radius: 0.25rem;
}
.Sidebar footer .ToggleTheme .Left {
  left: 0.25rem;
  transition: all 0.3s ease;
}
.Sidebar footer .ToggleTheme .Right {
  left: calc(50% - 0.25rem);
  transition: all 0.3s ease;
}
.Sidebar footer .ToggleTheme .ToggleLight, .Sidebar footer .ToggleTheme .ToggleDark {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  transition: all 0.3s ease;
  z-index: 1;
}
.Sidebar footer .ToggleTheme .ToggleLight span, .Sidebar footer .ToggleTheme .ToggleDark span {
  font-size: 0.75rem;
  color: var(--TextColor);
}
.Sidebar footer .ToggleTheme .ToggleLight svg path, .Sidebar footer .ToggleTheme .ToggleDark svg path {
  fill: var(--TextColor);
}
.Sidebar footer .Logout {
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  background: var(--Background);
  transition: all 0.3s ease;
  cursor: pointer;
}
.Sidebar footer .Logout svg path {
  fill: var(--TextColor);
}

.ClickOutside {
  display: none;
}

@media (max-width: 450px) {
  .Sidebar {
    position: absolute;
    display: none;
    height: calc(100% - 1rem);
  }
  .MobNav {
    display: flex;
    z-index: 11;
  }
  .ClickOutside {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: rgba(0, 0, 0, 0.7019607843);
    backdrop-filter: blur(3px);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/Sidebar.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,4CAAA;AAEJ;AADI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;AAGN;AADI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AAGN;AAFM;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAIR;AAFM;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAIR;AAAE;EACE,SAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAEJ;AADI;EACE,0CAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;AAGN;AADI;EACE,yBAAA;EACA,6BAAA;AAGN;AADI;EACE,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,0CAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;AAGN;AAAE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAEJ;AADI;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;AAGN;AAFM;EACE,YAAA;EACA,yBAAA;AAIR;AAFM;EACE,UAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,sBAAA;AAIR;AAFM;EACE,aAAA;EACA,yBAAA;AAIR;AAFM;EACE,yBAAA;EACA,yBAAA;AAIR;AAFM;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;AAIR;AAHQ;EACE,kBAAA;EACA,uBAAA;AAKV;AAFU;EACE,sBAAA;AAIZ;AACI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;AACN;AACQ;EACE,sBAAA;AACV;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE;IACE,kBAAA;IACA,aAAA;IACA,yBAAA;EAFF;EAIA;IACE,aAAA;IACA,WAAA;EAFF;EAIA;IACE,cAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,uCAAA;IACA,0BAAA;EAFF;AACF","sourcesContent":[".Sidebar{\n  height: 100%;\n  max-width: 13rem;\n  padding: 0.5rem;\n  background: var(--Foreground);\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  border-radius: 0.75rem;\n  overflow: auto;\n  min-width: 13rem;\n  header{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding-bottom: 0.75rem;\n    border-bottom: 0.0625rem solid var(--Stroke);\n    .Icon{\n      width: 2rem;\n      height: 2rem;\n      min-width: 2rem;\n      min-height: 2rem;\n      border-radius: 0.5rem;\n      background: var(--Background);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 1.125rem;\n      line-height: 1.125rem;\n      font-weight: 700;\n      color: var(--TextColor);\n      user-select: none;\n    }\n    .CompanyNameEmail{\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 0.125rem;\n      overflow: hidden;\n      .CompanyName{\n        font-size: 0.875rem;\n        font-weight: 700;\n        color: var(--TextColor);\n        cursor: default;\n      }\n      .CompanyEmail{\n        font-size: 0.625rem;\n        font-weight: 400;\n        color: var(--TextColor);\n      }\n    }\n  }\n  nav{\n    flex: 1;\n    padding: 0.25rem;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    .NavLink{\n      padding: 0.375rem 0.75rem 0.375rem 0.75rem;\n      border-radius: 0.5rem;\n      color: var(--TextColor);\n      font-size: 0.875rem;\n      cursor: pointer;\n      text-decoration: none;\n    }\n    .NavLink:hover{\n      color: var(--AccentColor);\n      background: var(--Background);\n    }\n    .Active{\n      background: var(--AccentColor);\n      color: #ffffff;\n      font-weight: 700;\n      padding: 0.375rem 0.75rem 0.375rem 0.75rem;\n      border-radius: 0.5rem;\n      font-size: 0.875rem;\n      cursor: pointer;\n      text-decoration: none;\n    }\n  }\n  footer{\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    .ToggleTheme{\n      flex: 1;\n      height: 2rem;\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      padding: 0.25rem;\n      background: var(--Background);\n      border-radius: 0.5rem;\n      transition: all 0.3s ease-in-out;\n      position: relative;\n      cursor: pointer;\n      .Opacity{\n        opacity: 0.5;\n        transition: all 0.3s ease;\n      }\n      .ToggleIndicator{\n        width: 50%;\n        height: 1.5rem;\n        position: absolute;\n        top: 0.25rem;\n        background: var(--Foreground);\n        border-radius: 0.25rem;\n      }\n      .Left{\n        left: 0.25rem;\n        transition: all 0.3s ease;\n      }\n      .Right{\n        left: calc(50% - 0.25rem);\n        transition: all 0.3s ease;\n      }\n      .ToggleLight, .ToggleDark{\n        flex: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.25rem;\n        transition: all 0.3s ease;\n        z-index: 1;\n        span{\n          font-size: 0.75rem;\n          color: var(--TextColor);\n        }\n        svg{\n          path{\n            fill: var(--TextColor);\n          }\n        }\n      }\n    }\n    .Logout{\n      width: 2rem;\n      height: 2rem;\n      border-radius: 0.5rem;\n      background: var(--Background);\n      transition: all 0.3s ease;\n      cursor: pointer;\n      svg{\n        path{\n          fill: var(--TextColor);\n        }\n      }\n    }\n  }\n}\n.ClickOutside{\n  display: none;\n}\n\n@media (max-width: 450px) {\n  .Sidebar{\n    position: absolute;\n    display: none;\n    height: calc(100% - 1rem);\n  }\n  .MobNav{\n    display: flex;\n    z-index: 11;\n  }\n  .ClickOutside{\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10;\n    background: #000000b3;\n    backdrop-filter: blur(3px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
